// src/pages/OAuthCallback.jsx
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, loginFailure } from '../redux/slices/userSlice';
import { useNavigate } from 'react-router-dom';

const REDIRECT_URI = `${window.location.origin}/oauth2/callback/`;

export default function OAuthCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ranRef = useRef(false);
  const user = useSelector(s => s.user);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const err = url.searchParams.get('error');
    const errDesc = url.searchParams.get('error_description');

    if (err) {
      dispatch(loginFailure(errDesc ? `${err}：${decodeURIComponent(errDesc)}` : err));
      return;
    }
    if (!code) {
      dispatch(loginFailure('未取得授權碼'));
      return;
    }

    dispatch(login({ code, redirect_uri: REDIRECT_URI }));
    navigate('/login', { replace: true })
  }, [dispatch]);

  useEffect(() => {
    navigate('/login', { replace: true });
  }, [user.status, user.error, navigate]);

  return <div style={{ padding: 24 }}>處理登入中…</div>;
}
